export default __webpack_public_path__ + "static/media/pin-work.8a14679c.svg";